import React from 'react';

import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';
import { dateFormat } from 'v2/formatters/date';
import { numberToBRL } from 'v2/helpers/money';
import { numberToPercentage } from 'v2/helpers/number';

import { fieldIsCurrency, fieldIsDate, fieldIsHtmlContent, fieldIsPercentage } from '../constants';

function formatHistoryInfo(field: string, value: string) {
  const regexCdnUrl = new RegExp(/^(https:\/\/cdn\.)/);
  const fieldHasDateValue = fieldIsDate.includes(field);
  const fieldHasCurrencyValue = fieldIsCurrency.includes(field);
  const fieldHasPercentageValue = fieldIsPercentage.includes(field);
  const fieldHasHtmlValue = fieldIsHtmlContent.includes(field);
  const fieldIsImage = field === 'image' && regexCdnUrl.test(value);
  const fieldIsRecurrenceCycle = field === 'recurrenceCycle';

  if (fieldHasDateValue) return dateFormat(value);
  if (fieldHasCurrencyValue) return numberToBRL(Number(value));
  if (fieldHasPercentageValue) return numberToPercentage(Number(value));
  if (fieldHasHtmlValue) return <NoDangerouslyHTML html={value} />;
  if (fieldIsImage) return <img src={value} width={100} height={100} />;
  if (fieldIsRecurrenceCycle) return `Após ${value} cobranças`;
  return value;
}

export default formatHistoryInfo;
